// vendor stuff
import 'bootstrap';

import './modules/bootstrap-validator';

// our stuff
import initializeSentry from './modules/sentry';
import initializeAlerts from './modules/backend-alert-handler';
import referrerhandler from './modules/referrer-handler';
import helpButtonHandler from './modules/help-button-handler';
import lazyBackgroundHandler from './modules/lazy-background-handler';

// Import pages related code
function importPageModule(r) {
    r.keys().forEach((key) => {
        const pageEl = document.querySelector('[data-page="' + key.substr(2).substr(0, key.length - 5) + '"]');
        if (pageEl) {
            r(key).default();
        }
    });
}
importPageModule(require.context('./pages/', false, /^.*\.js$/));

// Global required sentry service for each page
initializeSentry();

// Globally required modules
document.addEventListener('DOMContentLoaded', () => {
    // Initialize and show flash messages if provided in BE
    initializeAlerts();

    referrerhandler();
    helpButtonHandler();
    lazyBackgroundHandler();
});
